import { render } from "./SetUp.vue?vue&type=template&id=3d355090"
import script from "./SetUp.vue?vue&type=script&lang=ts"
export * from "./SetUp.vue?vue&type=script&lang=ts"
script.render = render

export default script